import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link", "section"];

  connect() {
    this.observer = null;
    this.scrollContainer = document.querySelector(".overflow-y-auto");
    this.initializeObserver();
    this.setInitialActiveSection();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initializeObserver() {
    const options = {
      root: this.scrollContainer,
      rootMargin: "-20% 0px -70% 0px",
      threshold: [0, 0.25, 0.5, 0.75, 1],
    };

    this.observer = new IntersectionObserver((entries) => {
      this.handleIntersection(entries);
    }, options);

    this.sectionTargets.forEach((section) => {
      this.observer.observe(section);
    });
  }

  navigateToSection(event) {
    event.preventDefault();
    const sectionId = event.currentTarget.dataset.section;
    const targetSection = this.sectionTargets.find(
      (section) => section.id === sectionId
    );

    if (targetSection && this.scrollContainer) {
      targetSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  handleIntersection(entries) {
    const visibleSections = entries
      .filter((entry) => entry.isIntersecting)
      .map((entry) => ({
        id: entry.target.id,
        ratio: entry.intersectionRatio,
      }))
      .sort((a, b) => b.ratio - a.ratio);

    if (visibleSections.length > 0) {
      this.setActiveSection(visibleSections[0].id);
    }
  }

  setActiveSection(sectionId) {
    this.linkTargets.forEach((link) => {
      const linkSection = link.dataset.section;

      if (linkSection === sectionId) {
        link.classList.remove("border-transparent");
        link.classList.add("border-brand");
      } else {
        link.classList.remove("border-brand");
        link.classList.add("border-transparent");
      }
    });
  }

  setInitialActiveSection() {
    if (this.sectionTargets.length > 0) {
      this.setActiveSection(this.sectionTargets[0].id);
    }
  }
}
